var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizationDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.922,
    height: 19.537,
    viewBox: "0 0 19.922 19.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160686",
    "data-name": "Group 160686",
    transform: "translate(-504.061 -129.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160603",
    "data-name": "Group 160603",
    transform: "translate(505.032 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1134",
    "data-name": "Rectangle 1134",
    width: 1.985,
    height: 10.779,
    transform: "translate(14.718 7.221)",
    fill: "#f49b31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M3.559,8.228,15.541,3.08l-.26,16.581L3.24,19.993Z",
    transform: "translate(-1.66 -2.176)",
    fill: "#adc7ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160601",
    "data-name": "Group 160601",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home-modern",
    d: "M7.356,20.6V15.772a1.076,1.076,0,0,1,1.036-1.111h2.08a1.076,1.076,0,0,1,1.036,1.111h0V20.6m0,0h4.152V3.316M11.507,20.6h6.92V10.449M1.82,20.6H3.2m16.616,0H3.2M1.82,8.716,5.972,7.1M17.043,2.78l-1.384.536m0,6.137,2.768.986m1.384.5-1.384-.5M5.972,7.1V2.78H3.2V20.6M13.588,4.13l2.08-.814M5.972,7.1,9.659,5.662",
    transform: "translate(-1.82 -2.78)",
    fill: "rgba(0,0,0,0)",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 0.512,
    cy: 0.53,
    rx: 0.512,
    ry: 0.53,
    transform: "translate(9.175 1.553)",
    fill: "#165cf3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationDarkIcon);
export default __webpack_public_path__ + "static/media/organization-dark-icon.c36311edd85af80cff07e2f3764a32b0.svg";
export { ForwardRef as ReactComponent };